import service from '@/utils/server';

const modName='/report/dashboardCsc/';

// 1. 顶部汇总
export const getSummary = data => {
  return service({
    url: modName + 'getSummary',
    method: 'post',
    data
  })
};

// 2. 各关单原因TOP3
export const getCloseOrderReason = data => {
  return service({
    url: modName + 'getCloseOrderReasonTop',
    method: 'post',
    data
  })
};

// 3. 首次送货满足率
export const getDeliveryRate = data => {
  return service({
    url: modName + 'getFirstDeliveryRate',
    method: 'post',
    data
  })
};

// 4. 客户订单
export const getCustomerOrder = data => {
  return service({
    url: modName + 'getCustomerTop10',
    method: 'post',
    data
  })
};

// 5. 订单分析-品类
export const getCategoryAnalysis = data => {
  return service({
    url: modName + 'getCategoryAnalysis',
    method: 'post',
    data
  })
};

// 6. 订单分析-订单类型
export const getOrderType = data => {
  return service({
    url: modName + 'getOrderTypeAnalysis',
    method: 'post',
    data
  })
};

// 7. 客户发货信息
export const getShipInfo = data => {
  return service({
    url: modName + 'getShipInfo',
    method: 'post',
    data
  })
};

/**
 * 退货信息
 * @param data
 * @returns {*}
 */
export const getDashboardRejectReturn = data => {
  return service({
    url: modName + 'getDashboardRejectReturn',
    method: 'post',
    data
  })
};

/**
 * top5
 * @param data
 * @returns {*}
 */
export const getDashboardTop5 = data => {
  return service({
    url: modName + 'getDashboardTop5',
    method: 'post',
    data
  })
};

/**
 * 整体满足率
 * @param data
 * @returns {*}
 */
export const getDashboardFillRate = data => {
  return service({
    url: modName + 'getDashboardFillRate',
    method: 'post',
    data
  })
};

// 导出
export const exportData = data => {
  let config = {
    timeout: 500000, // 请求超时时间
    responseType: "blob"
  };
  return service({
    ...config,
    url: modName + 'export',
    method: 'post',
    data
  })
};



// WEBPACK FOOTER //
// ./src/page/report/cscDashboard/api/index.js